import axios from 'axios'
import React, { Component, useEffect, useState } from 'react';
import { previewPdf2 } from './tchWiseServices';
const ViewSlider = (props) => {
    useEffect(() => {
        if (props.tchId && props.sessionId && props.flg) {
            let os = detectOS();
            if (os === "Android") {
                previewPdf2(props.sessionId, props.tchId, handlePreviewPdfResponseAndroid);
            } else {
                previewPdf2(props.sessionId, props.tchId, handlePreviewPdfResponse);
            }
        }
    })

    function handlePreviewPdfResponse(data) {
        let blob = new Blob([data.data], { type: 'application/pdf' }),
            url = window.URL.createObjectURL(blob);
        const iframe = document.getElementById('viewer');

        // iframe.onload = function () {
        //     // Revoke the URL only after iframe has loaded it
        //     URL.revokeObjectURL(url);
        // };
        iframe.setAttribute('src', url);
        // URL.revokeObjectURL(url);
    }


    function handlePreviewPdfResponseAndroid(data) {
        let blob = new Blob([data.data], { type: 'application/pdf' }),
            url = window.URL.createObjectURL(blob);
        url = window.URL.createObjectURL(blob)
        window.open(url, '_blank');
        props.setFlgClose();
    }

    const detectOS = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (/windows phone/i.test(userAgent)) {
            return 'Windows Phone';
        }
        if (/android/i.test(userAgent)) {
            return 'Android';
        }
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return 'iOS';
        }
        if (/Mac/i.test(userAgent)) {
            return 'MacOS';
        }
        if (/Win/i.test(userAgent)) {
            return 'Windows';
        }
        if (/Linux/i.test(userAgent)) {
            return 'Linux';
        }
        return 'Unknown OS';
    };

    return (
        <div>
            <button type="button" className="btn btn-info text-center " id="closeSlider" style={{ right: '70%', opacity: 1 }}
                onClick={(e) => props.setFlgClose()}>
                <span id="close" title="Close Slider" className="glyphicon glyphicon-remove"></span>
            </button>
            <div className="pdf" style={{ width: '100%', height: '96vh' }}>
                <iframe src={require("common/images/loader.gif")} title="Time Table Preview" id="viewer" style={{ width: '100%', height: '100%' }} />
            </div>
        </div>
    )
}
export default ViewSlider